const FEATURES = [
  {
    h: 'Mobile-first menu, rich visuals',
    p: 'Item detail with photography, ingredients, dietary tags, and configurable options.',
  },
  {
    h: 'Group ordering, shared cart',
    p: 'Six guests, one table, one bill — or split. Live cart updates across every device.',
  },
  {
    h: 'Live status, no flag-down',
    p: "Order placed → fired → plated → served. Guests see what's coming and when.",
  },
  {
    h: 'AI suggests, never pushes',
    p: 'Pairings and add-ons that fit the dish, the day, and the time. Designed to feel like a quiet host, not a popup.',
  },
];

export default function Mobile() {
  return (
    <section className="mobile" id="mobile">
      <div className="mobile-grid">
        <div className="mobile-text">
          <div className="kicker reveal">
            <span className="kicker-dot" />
            <span>The guest, in-hand</span>
          </div>
          <h2 className="display reveal-words">
            Your menu,
            <br />
            in their <em>palm.</em>
          </h2>
          <p className="lede reveal">
            A mobile-first interactive menu that scans, browses, customizes, and
            orders in fewer taps than most apps take to load. No app store. No
            friction.
          </p>

          <ul className="mobile-features">
            {FEATURES.map((f) => (
              <li className="reveal" key={f.h}>
                <span className="mf-num">→</span>
                <div>
                  <h5>{f.h}</h5>
                  <p>{f.p}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="mobile-phones">
          <div className="phone phone-back" data-phone="back">
            <div className="phone-frame">
              <div className="phone-notch" />
              <div className="phone-screen phone-screen-shot">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/mobile-bill.png`}
                  alt="Split bill & loyalty checkout"
                />
              </div>
            </div>
          </div>
          <div className="phone phone-front" data-phone="front">
            <div className="phone-frame">
              <div className="phone-notch" />
              <div className="phone-screen phone-screen-shot">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/mobile-menu.png`}
                  alt="Guest interactive menu"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
